@for (position of positions; track position) {
  <div class="toast-area" [ngClass]="position">
    @if ((toastsByPosition$ | async)?.[position]; as toasts) {
      @for (toast of toasts; track trackById($index, toast)) {
        <app-notifications-alert 
          [config]="toast" 
          (close)="onClose(toast.id)">
        </app-notifications-alert>
      }
    }
  </div>
}